export const ridersTypes = [
  {
    formikKey: 'isDetection',
    id: 'locateAndExtract',
    messageId: 'riders.locateAndExtract',
  },
  {
    formikKey: 'isLiable',
    id: 'travelThirdParty',
    messageId: 'riders.travelThirdParty',
  },
  {
    formikKey: 'isCharger',
    id: 'luggage',
    messageId: 'riders.luggage',
  },
  {
    formikKey: 'isEsports',
    id: 'extreme',
    messageId: 'riders.extreme',
  },
  {
    formikKey: 'isWsports',
    id: 'winterExtreme',
    messageId: 'riders.winterExtreme',
  },
  {
    formikKey: 'isTravelsc',
    id: 'cancellation',
    messageId: 'riders.cancellation',
  },
  {
    formikKey: 'isPccover',
    id: 'pcAndTablet',
    messageId: 'riders.pcAndTablet',
  },
  {
    formikKey: 'isMobilecover',
    id: 'mobile',
    messageId: 'riders.mobile',
  },
  {
    formikKey: 'isCancellationOfSelfParticipationOnRentedCar',
    id: 'cancellationOfSelfParticipationOnRentedCar',
    messageId: 'riders.cancellationOfSelfParticipationOnRentedCar',
  },
];